import { useParams, Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import { getArticleBySlug, getRelatedArticles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? getArticleBySlug(slug) : undefined;

  if (!article) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-16">
        <div className="text-center">
          <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-3">文章未找到</h1>
          <p className="text-foreground-600">请检查链接是否正确</p>
        </div>
      </div>
    );
  }

  const relatedArticles = getRelatedArticles(article);

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: article.publishDate,
    url: `https://liuhecai-zhinan.example.com/article/${article.slug}`,
    about: article.tags.map((tag) => ({ '@type': 'Thing', name: tag })),
  };

  return (
    <>
      <SEOHead
        title={`${article.title} - 六合彩指南`}
        description={article.excerpt}
        keywords={article.tags.join(',') + ',六合彩网站,六合彩指南'}
        canonicalUrl={`https://liuhecai-zhinan.example.com/article/${article.slug}`}
        ogType="article"
        schema={articleSchema}
      />
      <main className="pt-20 pb-10 md:pb-14">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-8">
            <article className="flex-1 min-w-0">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: article.categoryName, href: `/category/${article.category}` },
                  { label: article.title },
                ]}
              />

              <div className="mt-6">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-4 flex-wrap">
                  <Link
                    to={`/category/${article.category}`}
                    className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap"
                  >
                    {article.categoryName}
                  </Link>
                  <span>{article.readTime}</span>
                  <span>{article.publishDate}</span>
                  <span>作者：{article.author}</span>
                </div>

                <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4 leading-tight">
                  {article.title}
                </h1>

                <div className="aspect-[21/9] rounded-lg overflow-hidden mb-6">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={`${article.title} - 六合彩指南`}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex flex-wrap gap-2 mb-8">
                  {article.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-xs"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>

                <div
                  className="prose-custom text-foreground-800 leading-relaxed"
                  dangerouslySetInnerHTML={{
                    __html: article.content
                      .replace(/<h3>/g, '<h3 class="font-heading text-lg font-semibold text-foreground-900 mt-8 mb-3">')
                      .replace(/<p>/g, '<p class="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">')
                      .replace(/<strong>/g, '<strong class="text-foreground-900">'),
                  }}
                />
              </div>
            </article>

            <aside className="lg:w-[320px] flex-shrink-0">
              <div className="sticky top-24">
                <h3 className="font-heading font-semibold text-foreground-900 mb-4">相关文章</h3>
                <div className="space-y-4">
                  {relatedArticles.map((related) => (
                    <Link
                      key={related.slug}
                      to={`/article/${related.slug}`}
                      className="flex gap-3 group"
                    >
                      <div className="w-20 h-14 flex-shrink-0 rounded-md overflow-hidden">
                        <img
                          src={related.imageUrl}
                          alt={related.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="min-w-0">
                        <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2">
                          {related.title}
                        </h4>
                        <span className="text-xs text-foreground-500 mt-1 block">{related.publishDate}</span>
                      </div>
                    </Link>
                  ))}
                </div>

                <div className="mt-8 p-4 rounded-lg bg-secondary-50 border border-secondary-200/50">
                  <h4 className="font-heading font-semibold text-foreground-900 mb-2 text-sm">理性博彩提醒</h4>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    六合彩是一种娱乐活动，而非投资手段。请量力而行，设定预算，享受过程而非执着于结果。
                  </p>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </main>
    </>
  );
}